<template>
  <div
    class="search-token-container"
    :class="{ english: $i18n.locale === 'en', 'swap-search-token-container': $route.path === '/' }"
  >
    <div class="search-input-wrap">
      <SearchInput 
        v-if="!isMobileSize"
        :placeholder="$t('searchTokens')" 
        :searchIcon="searchIcon" 
        @focus="showSearchTokens"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchInput from '../common/SearchInput.vue';

export default {
  props: {
    searchIcon: {
      type: String,
    },
  },
  components: { SearchInput },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['isMobileSize']),
  },
  watch: {
  },
  created() {},

  methods: {
    showSearchTokens() {
      this.$emit('searchTokensVisible');
    },
  },
};
</script>

<style lang="less">
.search-token-container {
  display: block;
  position: relative;
  z-index: 10;
  height: 40px;
  width: 432px;
  padding: 0;
  box-sizing: border-box;
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  .search-input-wrap {
    .search-input{
      padding: 0 8px;
      &.bridge {
        background: var(--search-input-bg);
        border: 1px solid var(--search-input-border);
      }
    }
  }
}

@media screen and (max-width: 1430px) {
  .search-token-container {
    display: none;
  }
}
</style>
